enum NavigationSections {
  HIDE_PROGRESS_BAR = 'no_progress_bar',
  CHECK_ELIGIBILITY = 'check_eligibility',
  PAYMENT_DETAILS = 'payment_details',
  REVIEW_AND_PAY = 'review_and_pay',
}

export { NavigationSections };
